import { Link, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import api from '../utils/api'
import TagSelectionModal from '../components/TagSelectionModal'
import './Home.css'

const Home = () => {
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [vehicleSearch, setVehicleSearch] = useState('')
  const [searching, setSearching] = useState(false)

  const handleVehicleSearch = async (e) => {
    e.preventDefault()
    if (!vehicleSearch.trim()) return

    try {
      setSearching(true)
      const response = await api.get(`/qr/search?vehicleNumber=${encodeURIComponent(vehicleSearch.trim())}`)
      if (response.data.success && response.data.data.code_uuid) {
        navigate(`/qr/${response.data.data.code_uuid}`, {
          state: { vehicleNumber: vehicleSearch.trim().toUpperCase() }
        })
      }
    } catch (error) {
      console.error('Search error:', error)
      alert(error.response?.data?.message || 'No vehicle found with this number.')
    } finally {
      setSearching(false)
    }
  }

  return (
    <div className="home">
      <div className="hero-background"></div>

      {/* SECTION 1: INITIAL HERO (VIDEO SCREEN) */}
      <section className="hero">
        <div className="container hero-video-grid">
          <div className="hero-content">
            <span className="badge-tag">REIMAGINING VEHICLE CONTACT</span>
            <h1 className="hero-title-main">
              Connect Securely, <br />
              <span className="text-gradient">Protect Your Privacy.</span>
            </h1>
            <p className="hero-subtitle-main">
              The secure, privacy-first way to connect with vehicle owners.
              Scan a QR code to resolve parking issues instantly without sharing phone numbers.
            </p>
            <div className="hero-cta-main">
              <Link to="/scan" className="btn btn-primary pulse-animation">
                Scan QR Code
              </Link>
              <Link to="/products" className="btn btn-secondary">
                Get Your Tag
              </Link>
            </div>

            <div className="vehicle-search-container" style={{ marginTop: '2rem' }}>
              <form onSubmit={handleVehicleSearch} className="vehicle-search-form">
                <input
                  type="text"
                  placeholder="Enter Vehicle Number (e.g. TS09EA1234)"
                  value={vehicleSearch}
                  onChange={(e) => setVehicleSearch(e.target.value.toUpperCase())}
                  className="search-input"
                  disabled={searching}
                />
                <button type="submit" className="search-btn" disabled={searching}>
                  {searching ? '...' : 'Search'}
                </button>
              </form>
              <p className="search-info">Directly contact owner by searching vehicle number.</p>
            </div>
          </div>

          <div className="hero-visual-video">
            <div className="video-player-container-main">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="preview-video-main"
              >
                <source src="https://assets.mixkit.co/videos/preview/mixkit-going-down-a-curved-highway-downward-at-night-42217-large.mp4" type="video/mp4" />
              </video>
              <div className="video-overlay-glow"></div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2: TAG SHOWCASE (PREVIOUS WORK) */}
      <section className="tag-showcase-section">
        <div className="container hero-grid">
          <div className="hero-content">
            <span className="badge-tag">CAR AND BIKE PARKING TAG</span>
            <h2 className="section-title-new">
              Privacy and Security at its Best, <span className="text-highlight">NAH44 Vehicle Parking Tag.</span>
            </h2>

            <div className="features-checklist">
              <div className="feature-item-inline">
                <span className="feature-num">1.</span>
                <div className="feature-text">
                  <strong>Private Contact</strong>
                  <p>Your contact details are not shared when someone contacts you.</p>
                </div>
              </div>
              <div className="feature-item-inline">
                <span className="feature-num">2.</span>
                <div className="feature-text">
                  <strong>WhatsApp Update</strong>
                  <p>Receive Updates on your WhatsApp, SMS and Also Masked Calls.</p>
                </div>
              </div>
              <div className="feature-item-inline">
                <span className="feature-num">3.</span>
                <div className="feature-text">
                  <strong>Upload Files</strong>
                  <p>Add your vehicle documents, access with OTP.</p>
                </div>
              </div>
              <div className="feature-item-inline">
                <span className="feature-num">4.</span>
                <div className="feature-text">
                  <strong>Emergency Call</strong>
                  <p>Add your emergency contact details in the tag.</p>
                </div>
              </div>
            </div>

            <div className="hero-actions-new">
              <div className="amazon-buy">
                <img src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg" alt="Amazon" className="amazon-logo-img" />
                <span>Buy now on Amazon</span>
              </div>
              <button className="btn-add-to-cart" onClick={() => setIsModalOpen(true)}>
                <span>🛒</span> Add to Cart
              </button>
            </div>
          </div>
          <div>
            <img src="/card.png" alt="NAH44" className="tag-image-main" />
          </div>

          {/* <div className="hero-tag-visual">
            <div className="tag-container">
              <div className="tag-stripes"></div>
              <div className="nah44-tag-card">
                <div className="tag-left-panel">
                  <div className="tag-qr-placeholder">
                    <img src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=NAH44-DEMO" alt="QR Code" />
                  </div>
                  <div className="tag-branding-mini">
                    <div className="mini-logo">NAH44</div>
                    <div className="india-flag">India</div>
                  </div>
                  <div className="tag-icons-row">
                    <div className="tag-icon-item">Wrong Parking</div>
                    <div className="tag-icon-item">Emergency</div>
                  </div>
                </div>
                <div className="tag-right-panel">
                  <div className="tag-main-logo">
                    <div className="logo-text-v2 tag-logo-adjust">
                      <span className="logo-part-nah">NAH</span>
                      <span className="logo-part-44">44</span>
                    </div>
                  </div>
                  <h2 className="tag-call-to-action">
                    Scan the code <br />
                    to contact the <br />
                    vehicle owner.
                  </h2>
                  <div className="tag-footer-text">
                    SCAN USING PHONE CAMERA, GOOGLE LENS OR ANY QR SCANNER APP. VISIT NAH44.COM FOR MORE.
                  </div>
                </div>
              </div>
              <div className="pointer p1"><span>Scan using any camera phone</span></div>
              <div className="pointer p2"><span>NAH 44 branding</span></div>
              <div className="pointer p3"><span>"SCAN TO CONTACT" Clear message</span></div>
            </div>
          </div> */}
        </div>
      </section>

      {/* SECTION 3: APP SHOWCASE (MASKED CALLS) */}
      <section className="app-showcase-section">
        <div className="container hero-grid">
          <div className="hero-content">
            <span className="badge-tag">THE CAR PARKING TAG.</span>
            <h2 className="section-title-new">
              Masked Calls, SMS, WhatsApp <span className="text-highlight">and Emergency Help.</span>
            </h2>

            <div className="app-feature-list">
              <div className="app-feature-item">
                <span className="feature-arrow">^</span>
                <div className="app-feature-text">
                  <strong>Upload Files</strong>
                  <p>Add your vehicle documents, access with OTP.</p>
                </div>
              </div>
              <div className="app-feature-item">
                <span className="feature-arrow">v</span>
                <div className="app-feature-text">
                  <strong>Vehicle IN and Out Logs</strong>
                </div>
              </div>
              <div className="app-feature-item">
                <span className="feature-arrow">v</span>
                <div className="app-feature-text">
                  <strong>One time Buy</strong>
                </div>
              </div>
            </div>

            <div className="hero-actions-new">
              <div className="amazon-buy">
                <img src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg" alt="Amazon" className="amazon-logo-img" />
                <span>Buy now on Amazon</span>
              </div>
              <button className="btn-add-to-cart" onClick={() => setIsModalOpen(true)}>
                Add to Cart
              </button>
            </div>
          </div>

          <div className="hero-app-visual">
            <div className="phone-mockup-container">
              <div className="phone-frame">
                <div className="phone-screen">
                  <div className="screen-header">
                    <span className="time">12:36 PM</span>
                    <div className="status-icons">📱 🔋</div>
                  </div>
                  <div className="app-header-mini">
                    <div className="nah-logo-mini">NAH<span>44</span></div>
                    <div className="notif-bell">Notice</div>
                  </div>
                  <div className="app-content-mini">
                    <p className="contact-text">Contact vehicle owner.</p>
                    <h3 className="car-details"><span className="status-dot"></span> RADIANT RED M. AMAZE 1.2 S MT</h3>
                    <div className="reg-badge">UP85BF ####</div>
                    <p className="prompt">Would you like to call or text the owner?</p>
                    <div className="mini-btn blue">
                      <span>Masked Call</span>
                    </div>
                    <div className="mini-btn outline">
                      <span>Message</span>
                    </div>
                    <p className="emergency-prompt">Do you think the vehicle has an accident and needs to be contacted family members or emergency numbers?</p>
                    <button className="emergency-btn-mini">Emergency</button>
                  </div>
                </div>
              </div>

              {/* Phone Annotations */}
              <div className="phone-pointer pp1"><strong>Masked Call</strong></div>
              <div className="phone-pointer pp2"><strong>WhatsApp + SMS</strong></div>
              <div className="phone-pointer pp3">Auto Detect Vehicle color and model.</div>
              <div className="phone-pointer pp4">Emergency and Accident help</div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4: PHYSICAL TAG SHOWCASE */}
      <section className="physical-tag-section">
        <div className="container hero-grid">
          <div className="hero-visual-physical">
            <div className="physical-tag-wrapper">
              <img src="/image.png" alt="NAH44 Physical Tag" className="tag-image-main" />
              <div className="image-glow"></div>
            </div>
          </div>
          
          <div className="hero-content">
            <span className="badge-tag">PHYSICAL SMART TAG</span>
            <h2 className="section-title-new">
              The <span className="text-highlight">Ultimate Smart Tag</span> for Every Vehicle.
            </h2>
            <p className="section-description">
              Our premium physical tags are more than just stickers. They are your secure gateway to 
              hassle-free vehicle management and privacy-first communication. Simply stick it on your 
              windshield and stay connected safely.
            </p>

            <div className="features-checklist">
              <div className="feature-item-inline">
                <span className="feature-num">✓</span>
                <div className="feature-text">
                  <strong>Universal Scanning</strong>
                  <p>Scan using any Phone Camera, Google Lens, or any UPI App Scanner (PhonePe, GPay, etc.)</p>
                </div>
              </div>
              <div className="feature-item-inline">
                <span className="feature-num">✓</span>
                <div className="feature-text">
                  <strong>Emergency Ready</strong>
                  <p>Dedicated emergency contact support for quick response during accidents or towing.</p>
                </div>
              </div>
              <div className="feature-item-inline">
                <span className="feature-num">✓</span>
                <div className="feature-text">
                  <strong>Premium Quality</strong>
                  <p>Weather-resistant, sun-protected, and durable design that lasts for years.</p>
                </div>
              </div>
            </div>

            <div className="hero-actions-new">
              <Link to="/products" className="btn btn-primary">
                Get Your Tag
              </Link>
              <div className="amazon-buy">
                <img src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg" alt="Amazon" className="amazon-logo-img" />
                <span>Available on Amazon</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5: BUSINESS SHOWCASE */}
      <section className="business-showcase-section">
        <div className="container hero-grid">
          <div className="hero-content">
            <span className="badge-tag">FOR BUSINESS & CORPORATES</span>
            <h2 className="section-title-new">
              Get <span className="text-highlight">NAH44 Tag</span> for Your Business.
            </h2>
            <p className="section-description">
              Elevate your brand visibility and streamline vehicle management with our 
              enterprise-grade co-branded solutions. Perfect for Garages, Societies, 
              Insurance Companies, and Corporates.
            </p>

            <div className="app-feature-list">
              <div className="app-feature-item">
                <span className="feature-arrow">✓</span>
                <div className="app-feature-text">
                  <strong>Custom Branding</strong>
                  <p>Get tags with your company logo and name. Your logo appears instantly when scanned.</p>
                </div>
              </div>
              <div className="app-feature-item">
                <span className="feature-arrow">✓</span>
                <div className="app-feature-text">
                  <strong>Vehicle Log Management</strong>
                  <p>Add your staff to manage and monitor vehicle logs in real-time.</p>
                </div>
              </div>
              <div className="app-feature-item">
                <span className="feature-arrow">✓</span>
                <div className="app-feature-text">
                  <strong>Special CRM Access</strong>
                  <p>A dedicated dashboard to manage your tags, staff, and view analytics.</p>
                </div>
              </div>
              <div className="app-feature-item">
                <span className="feature-arrow">✓</span>
                <div className="app-feature-text">
                  <strong>Increase Loyalty & Branding</strong>
                  <p>Dedicated support to manage your business needs and boost customer engagement.</p>
                </div>
              </div>
            </div>

            <div className="hero-actions-new">
              <button className="btn btn-primary" onClick={() => navigate("/franchise")}>
                Contact for Business
              </button>
              <div className="amazon-buy">
                <span>Garages • Societies • Insurance • Corporates</span>
              </div>
            </div>
          </div>

          <div className="hero-visual-business">
            <div className="business-tag-wrapper">
              <img src="/business-tag.png" alt="NAH44 Business Co-branded Tag" className="tag-image-main" />
              <div className="business-overlay-label">CO-BRANDED OPTIONS AVAILABLE</div>
              <div className="image-glow business"></div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6: TICKER TAPE */}
      <div className="ticker-tape">
        <div className="ticker-content">
          <span>⭐ One time purchase.</span>
          <span>⭐ Privacy of phone.</span>
          <span>⭐ Best Seller on amazon.</span>
          <span>⭐ COD Available.</span>
          <span>⭐ We not only manage this category, we invent it.</span>
          <span>⭐ One time purchase.</span>
          <span>⭐ Privacy of phone.</span>
          <span>⭐ Best Seller on amazon.</span>
          <span>⭐ COD Available.</span>
          <span>⭐ We not only manage this category, we invent it.</span>
        </div>
      </div>

      <section className="features">
        <div className="container">
          <div className="section-header text-center mb-8">
            <h2>Why Choose NAH44?</h2>
            <p>Premium features designed for your peace of mind.</p>
          </div>

          <div className="features-grid">
            <div className="feature-card glass-card">
              <h3>Privacy First</h3>
              <p>Your contact details remain hidden. We bridge the call securely.</p>
            </div>
            <div className="feature-card glass-card">
              <h3>Instant Alert</h3>
              <p>Get notified immediately via SMS and WhatsApp when someone scans your tag.</p>
            </div>
            <div className="feature-card glass-card">
              <h3>Works Offline</h3>
              <p>Our NFC tags work even without internet, ensuring you're always reachable.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="features products-section">
        <div className="container">
          <div className="section-header text-center mb-8">
            <h2>Our Products</h2>
            <p>Comprehensive solutions for vehicle contact and business management</p>
          </div>
          <div className="features-grid">
            <div className="feature-card glass-card clickable" onClick={() => setIsModalOpen(true)}>
              <h3>NAH44 Tags</h3>
              <p>Generate unlimited QR codes for your vehicles. Enable others to contact you securely when your vehicle is involved in parking issues or accidents.</p>
            </div>
            <div className="feature-card glass-card">
              <h3>Franchise Management & QR Menu Ordering</h3>
              <p>Complete restaurant management platform with QR-based digital menus, order processing, and billing. Manage multiple locations, track orders in real-time, and streamline operations with Kitchen Display System (KDS) integration.</p>
            </div>
            <div className="feature-card glass-card">
              <h3>Recharge Platform</h3>
              <p>Mobile, DTH, and utility bill payments with secure payment gateways. Fast and reliable recharge services.</p>
            </div>
          </div>
        </div>
      </section>

      <TagSelectionModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  )
}

export default Home
